import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "my-5" }
const _hoisted_2 = { class: "flex gap-6" }
const _hoisted_3 = ["autofocus", "id", "onInput", "onKeydown", "readonly"]
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { class: "mt-7" }
const _hoisted_6 = {
  key: 0,
  class: "text-red text-center mb-5"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "s20" }

import { reactive, ref } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationOtpForm',
  props: { accessToken: { type: String, required: true } },
  emits: ['otpVerified'],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const digitsLength = ref(6);
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const otpInputs = ref<any[]>([]);
    const formErrors = reactive({
        otp_code: '',
    });

    function validate() {
        let isValid = true;

        formErrors.otp_code = '';
        if (otpInputs.value.length == 0) {
            formErrors.otp_code ="Le code OTP est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.post(`/backoffice/auth/verification_otp`, { otp_code: otpInputs.value.map(i => i.value).join('') }, {
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            });
            if (httpResponse.data.success == true) {
                emit("otpVerified");
            } else {
                errorMessage.value = 'Le code OTP saisi est incorrect';
                
                for (var i = 0; i < otpInputs.value.length; i++) {
                    otpInputs.value[i].value = null;
                    if (i == 0) {
                        otpInputs.value[i].focus();
                    }
                }
            }
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    // Quand on tape un chiffre
    function onInput(event: any, index: number) {
        const input = event.target
        const value = input.value

        // Si on a bien 1 caractère, on passe au suivant
        if (value.length === 1 && index < otpInputs.value.length - 1) {
            otpInputs.value[index + 1].focus()
        }

        // Facultatif : empêcher de taper autre chose qu’un chiffre
        if (!/^[0-9]$/.test(value)) {
            input.value = ''
        }

        if (index + 1 == digitsLength.value) {
            onSubmit();
        }
    }

    // Quand on appuie sur backspace
    function onBackspace(event: any, index: number) {
        const input = event.target
        if (input.value === '' && index > 0) {
            otpInputs.value[index - 1].focus()
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "font-semibold my-8 text-center" }, [
      _createTextVNode("Vérification OTP "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _createElementVNode("form", {
      class: "form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("label", null, [
          _createTextVNode("Entrez le code de sécurité "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(digitsLength.value, (digit, index) => {
            return (_openBlock(), _createElementBlock("input", {
              autofocus: index == 0,
              key: index,
              type: "text",
              id: 'otp_code_' + index,
              class: "form-control-code",
              maxlength: "1",
              onInput: ($event: any) => (onInput($event, index)),
              onKeydown: _withKeys(($event: any) => (onBackspace($event, index)), ["backspace"]),
              ref_for: true,
              ref_key: "otpInputs",
              ref: otpInputs,
              readonly: loading.value
            }, null, 40, _hoisted_3))
          }), 128))
        ])
      ]),
      (!!formErrors['otp_code'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formErrors['otp_code']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_custom_button, {
              loading: loading.value,
              classesList: 'btn xl w-100',
              type: "submit"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: "/icons/icon-menu-securite.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Valider", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ], 32)
  ]))
}
}

})